export default {
    path: '/Ali-pay',
    meta: {
        title: '付款',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Ali-pay`),
}



// WEBPACK FOOTER //
// ./src/views/ByOther/router.js